import React from 'react';
import { Reveal } from './ui/Reveal';
export function Guarantee() {
  return <section className="w-full bg-cream py-20 sm:py-24" data-id="element-117" data-mp="1o3x4tt31p256">
      <div className="mx-auto max-w-4xl px-5" data-id="element-118" data-mp="1o3dm4a5km9q3">
        <Reveal data-id="element-119" data-mp="2236cg4d6qnxj">
          <div className="flex flex-col items-center gap-8 rounded-3xl border border-sand bg-sand/50 p-8 text-center sm:p-10" data-id="element-120" data-mp="223ob17nble8m">
            <div className="flex h-28 w-28 flex-shrink-0 flex-col items-center justify-center rounded-full border-4 border-sage-deep/20 bg-cream" data-id="element-121" data-mp="1x4uypijrrta1">
              <span className="font-serif text-5xl font-semibold text-sage-deep" data-id="element-122" data-mp="14fxu2i8hduzr">7</span>
              <span className="text-[10px] font-semibold uppercase tracking-widest text-muted" data-id="element-123" data-mp="1j4k7ufigmeov">
                días
              </span>
            </div>
            <div data-id="element-124" data-mp="1ec98bdrmsuwu">
              <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-125" data-mp="1ebr1jn7ceyao">
                Garantía Yoga 360
              </p>
              <h2 className="mt-2 font-serif text-2xl font-semibold text-ink sm:text-3xl" data-id="element-126" data-mp="lpogkc78ugsr">
                Probalo durante 7 días sin riesgo
              </h2>
              <p className="mt-3 leading-relaxed text-muted" data-id="element-127" data-mp="oxf8s5dqyhqg">
                Abrís los 7 tomos. Revisás los 5 bonos. Los usás en tu clase si querés. Si en
                7 días sentís que no es para vos, te devolvemos el 100%.
              </p>
              <p className="mt-2 text-sm font-medium text-ink/70" data-id="element-128" data-mp="12r686kxrkl8g">
                Sin preguntas. Sin formularios eternos. Sin vueltas.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}